import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  //para informar del menu
  halloweenMenu$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //para informar de las opciones del formulario de registro
  optionsMenu$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);



  getHalloweenMenu$() {
    return this.halloweenMenu$.asObservable();
  }

  getOptionsMenu$() {
    return this.optionsMenu$.asObservable();
  }

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }


  fetchAllParameters(): Observable<any> {
    console.log("me llamaron");
    return this.httpService.get(this.endpoints.parameters);
  }

  fetchAllParametersProm(): Promise<any> {
    return this.httpService.get(this.endpoints.parameters).toPromise();
  }

  fetchParameterById(id: number): Observable<any> {
    return this.httpService.get(this.endpoints.parameters + '/'+ id);
  } 

  fetchParameterByName(name: string): Observable<any> {
    return this.httpService.get(this.endpoints.parameters + '/parameter/'+ name);
  } 


  async getValidityParam(preparam: string, parameters: any []) {
    let today = new Date();
    let paramList = parameters.filter((elem: any) =>
      elem.parameter_name.startsWith(preparam)
    );
    
    //valida si tiene vigencia inicio
    //let start = '';
    //let end = '';
    let startDate = {};
    let endDate = {};
    let active = false;
    paramList.forEach((elem: any) => {
      if (elem.parameter_name.endsWith('START_DATE')) {
        //start = elem.parameter_value;
        startDate = new Date(elem.parameter_value + " ");
      }
      if (elem.parameter_name.endsWith('END_DATE')) {
        //end = elem.parameter_value;
        endDate = new Date(elem.parameter_value + " ");
      }
      if (elem.parameter_name.endsWith('ACTIVE')) {
        active = elem.parameter_value == 'true' ? true : false;
      }
    });

    //let startDate = new Date(start + " ");
    //let endDate = new Date(end + " ");

    console.log(startDate);
    console.log(endDate);
    console.log(active);

    if (today < endDate && today > startDate) {
      this.halloweenMenu$.next(true);
      return true;
    } else {
      this.halloweenMenu$.next(false);
      return false;
    }
    
  }


  async getHallowenParam(parameterPrefix: string) {

    let parameters = await this.fetchAllParametersProm();
    let today = new Date();
    let paramList = parameters.data.filter((elem: any) =>
      elem.parameter_name.startsWith(parameterPrefix)
    );
    
    //valida si tiene vigencia inicio

    let startDate = {};
    let endDate = {};
    let active = false;
    paramList.forEach((elem: any) => {
      if (elem.parameter_name.endsWith('START_DATE')) {
        //start = elem.parameter_value;
        startDate = new Date(elem.parameter_value);
      }
      if (elem.parameter_name.endsWith('END_DATE')) {
        //end = elem.parameter_value;
        endDate = new Date(elem.parameter_value + 'T23:59:59.000Z');
      }
      if (elem.parameter_name.endsWith('ACTIVE')) {
        active = elem.parameter_value == 'true' ? true : false;
      }
    });

    if (today < endDate && today > startDate) {
      this.halloweenMenu$.next(true);
      return true;
    } else {
      this.halloweenMenu$.next(false);
      return false;
    }
    
  }


  async getMenuOptionsParam(parameterPrefix: string) {
    console.log("aquiii");
    let parameters = await this.fetchAllParametersProm();
    let today = new Date();
    let paramList = parameters.data.filter((elem: any) =>
      elem.parameter_name.startsWith(parameterPrefix)
    );
    
    //valida si tiene vigencia inicio
    let startDate = {};
    let endDate = {};
    let active = false;
    paramList.forEach((elem: any) => {
      if (elem.parameter_name.endsWith('START_DATE')) {
        //start = elem.parameter_value;
        startDate = new Date(elem.parameter_value);
      }
      if (elem.parameter_name.endsWith('END_DATE')) {
        //end = elem.parameter_value;
        endDate = new Date(elem.parameter_value + 'T23:59:59.000Z');
      }
      if (elem.parameter_name.endsWith('ACTIVE')) {
        active = elem.parameter_value == 'true' ? true : false;
      }
    });

    if (today < endDate && today > startDate) {
      this.optionsMenu$.next(true);
      return true;
    } else {
      this.optionsMenu$.next(false);
      return false;
    }
    
  }
}
